/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict";

    interface ISchoolOfferingProgramScope extends ng.IScope {
        vm: SchoolOfferingProgram;
    }

    interface ISchoolOfferingProgram {
        program: string;
        programId: number;
        results: any;

    }

    class SchoolOfferingProgram implements ISchoolOfferingProgram {
        static controllerId: string = "schoolOfferingProgram";
        static $inject: Array<string> = ["$rootScope", "$uibModal", "common", "$routeParams", "Restangular", "config"];
        private log;
        program: string;
        results: Array<any>;
        newResults: any;
        programId: number;
        programType: any;
        programOption: any;
        schoolsLoaded: boolean;
        sortBy: any;
        sortDirection: any;
        currentPage: number;
        totalInstitutions: number;
        transitionsUrl: string;
        descriptionId: string;
        isSaved: boolean;
        buttonClass: any;

        logSuccess: (msg, data?, showHowl?) => void;

        constructor(private $rootScope: ng.IRootScopeService, private $uibModal: ng.ui.bootstrap.IModalService, private common: ICommonFactory, private $routeParams: ng.route.IRouteParamsService, private Restangular: Restangular.IService, private config: IConfig) {
            this.log = common.logger.getLogFn(SchoolOfferingProgram.controllerId);
            this.logSuccess = this.common.logger.getLogFn(SchoolOfferingProgram.controllerId, "success");
            this.transitionsUrl = config.transitionsUrl;
            this.programId = $routeParams["programId"];

            this.$rootScope.$on("$routeChangeStart", (event, next, current): void => {
                sessionStorage.setItem("ProgramLevel", this.programOption);
            });

            this.activate();
        }

        activate() {
            var promises = [];
            this.common.activateController(promises, SchoolOfferingProgram.controllerId)
                .then(() => {
                    this.common.authentication.isLoggedIn().then((loggedIn) => {
                        if (loggedIn) {
                            this.programSavedCheck();
                        }
                        this.log("Activated Schools Offering Program View");
                        this.programOption = "Certificate";
                        var test = sessionStorage.getItem("ProgramLevel");
                        if (test) {
                            this.programOption = test;
                            sessionStorage.removeItem("ProgramLevel");
                        }
                        this.schoolsLoaded = false;
                        this.isSaved = false;
                        this.buttonClass = "";
                        this.sortBy = "School";
                        this.sortDirection = "ASC";
                        this.currentPage = 1;
                        this.getSchools();
                    });

                });
        }

        sort(sortValue: string) {
            if (this.sortBy === sortValue) {
                this.sortDirection = this.sortDirection === "ASC" ? "DESC" : "ASC";
            } else {
                this.sortBy = sortValue;
            }
            this.getSchools();
        }

        getSchools = () => {
            this.Restangular.one("ExploreProgramMajors/getschools/" + this.programId + "/" + this.programOption + "/" + this.sortBy + "/" + this.sortDirection + "/" + this.currentPage).get().then((results) => {
                this.program = results.programName;
                this.newResults = results.institutions;
                this.descriptionId = results.xapDescriptionId;
                this.schoolsLoaded = true;
                this.totalInstitutions = results.totalInstitutions;
            }, (reason) => {
                console.error(reason);
            });
        }

        programSavedCheck() {
            this.Restangular.one("ExploreProgramMajors/ProgramSavedCheck/" + this.programId).get().then((results) => {
                this.isSaved = results.saved;
                if (this.isSaved)
                    this.buttonClass = { "cursor": "not-allowed", "pointer-events": "none", "color": "grey", "text-decoration": "none" };
            }, (reason) => {
                console.error(reason);
            });
        }

        saveProgram() {
            var data = { Id: this.programId };
            this.Restangular.all("ExploreProgramMajors/SaveProgram").post(data).then((results) => {
                this.isSaved = true;
                this.buttonClass = { "cursor": "not-allowed", "pointer-events": "none", "color": "grey", "text-decoration": "none" }
                this.logSuccess("Program/Major has been saved", null, true);
            }, (reason) => {
                console.error(reason);
            });
        }

        open(id) {
            var data = {};
            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/apphub/startNewAppModal.html',
                controller: 'startNewAppModal',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    data: function () { return data; }
                },
            });

            modalInstance.result
                .then(() => { this.log("update SchoolOfferingProgram data to reflect new apps"); });
        }

    }

    angular.module("app").controller(SchoolOfferingProgram.controllerId, SchoolOfferingProgram);
}